import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { ProcessSection } from './components/ProcessSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { ProductCategoriesSection } from './components/ProductCategoriesSection';
import { IndustriesSection } from './components/IndustriesSection';
import { TeamSection } from './components/TeamSection';
import { CaseStudiesSection } from './components/CaseStudiesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { InsightsSection } from './components/InsightsSection';
import { FAQSection } from './components/FAQSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { PageLoader } from './components/PageLoader';
import { BackToTop } from './components/BackToTop';
import { ChatWidget } from './components/ChatWidget';
import { StockLiquidationSection } from './components/StockLiquidationSection';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { CookiePolicyPage } from './pages/CookiePolicyPage';
import { SitemapPage } from './pages/SitemapPage';
function HomePage() {
  useEffect(() => {
    document.title = '888 Sourcing Limited | Global Product Sourcing & Market Development';
    // Force title update
    const titleElement = document.querySelector('title');
    if (titleElement) {
      titleElement.textContent = '888 Sourcing Limited | Global Product Sourcing & Market Development';
    }
  }, []);
  return <div className="min-h-screen bg-[#0a1628] text-white selection:bg-[#d4a853] selection:text-[#0a1628]" data-id="element-0">
      <PageLoader data-id="element-1" />
      <Navigation data-id="element-2" />

      <main data-id="element-3">
        <div id="home" data-id="element-4">
          <HeroSection data-id="element-5" />
        </div>

        <div id="services" data-id="element-6">
          <ServicesSection data-id="element-7" />
        </div>

        <div id="stock-liquidation" data-id="element-8">
          <StockLiquidationSection data-id="element-9" />
        </div>

        <div id="process" data-id="element-10">
          <ProcessSection data-id="element-11" />
        </div>

        <div id="products" data-id="element-12">
          <ProductCategoriesSection data-id="element-13" />
        </div>

        <div id="about" data-id="element-14">
          <AboutSection data-id="element-15" />
        </div>

        <div id="retail-network" data-id="element-16">
          <IndustriesSection data-id="element-17" />
        </div>

        <TeamSection data-id="element-18" />

        <CaseStudiesSection data-id="element-19" />

        <TestimonialsSection data-id="element-20" />

        <InsightsSection data-id="element-21" />

        <FAQSection data-id="element-22" />

        <div id="contact" data-id="element-23">
          <ContactSection data-id="element-24" />
        </div>
      </main>

      <Footer data-id="element-25" />

      {/* Global Overlays */}
      <BackToTop data-id="element-26" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-27">
      <Routes data-id="element-28">
        <Route path="/" element={<HomePage data-id="element-30" />} data-id="element-29" />
        <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-32" />} data-id="element-31" />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-34" />} data-id="element-33" />
        <Route path="/cookie-policy" element={<CookiePolicyPage data-id="element-36" />} data-id="element-35" />
        <Route path="/sitemap" element={<SitemapPage data-id="element-38" />} data-id="element-37" />
      </Routes>
    </BrowserRouter>;
}